import { Link, type LinkProps } from 'react-router-dom';
import { useCallback, useRef } from 'react';

// Prefetches the route's chunk on hover/touchstart/focus.
// `prefetch` is the same dynamic import factory you pass to lazy().
// Pass via the `prefetch` prop OR drop into App.tsx where the route map is built.
type Props = LinkProps & { prefetch?: () => Promise<unknown> };

export function PrefetchLink({ prefetch, onMouseEnter, onTouchStart, onFocus, ...rest }: Props) {
  const fired = useRef(false);
  const trigger = useCallback(() => {
    if (fired.current || !prefetch) return;
    fired.current = true;
    prefetch().catch(() => {
      fired.current = false;
    });
  }, [prefetch]);

  return (
    <Link
      {...rest}
      onMouseEnter={(e) => {
        trigger();
        onMouseEnter?.(e);
      }}
      onTouchStart={(e) => {
        trigger();
        onTouchStart?.(e);
      }}
      onFocus={(e) => {
        trigger();
        onFocus?.(e);
      }}
    />
  );
}

export default PrefetchLink;
